/**
 * Checks if a CSV string fully and exactly contains the specified item.
 * @param {string|null|undefined} list - The CSV string.
 * @param {string|null|undefined} item - The item to search for.
 * @returns {boolean} True if the item is found as a full element, false otherwise.
 */
export function csvContains(list, item) {
    if (list == null) return false;
    item = (item || '').trim();
    if (item === '') return false;
    // Add commas to both ends to ensure exact match
    return (',' + list + ',').includes(',' + item + ',');
}

